import styled, { css } from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  background: transparent;
  border-bottom: 1px solid #3d3d3d;
  margin-bottom: 1rem;
`;

type ButtonProps = {
  isActive: boolean;
};

export const Button = styled.button<ButtonProps>`
  background: transparent;
  border: 1px solid transparent;
  font-family: DM Sans, sans-serif;
  font-size: 1rem;
  font-weight: 400;
  margin-right: 1.5rem;
  color: var(--white);
  padding-bottom: 0.88rem;

  &:hover {
    color: var(--primary);
  }

  ${({ isActive }) =>
    isActive &&
    css`
      border-bottom: 1px solid var(--primary);
      color: var(--primary);
      font-weight: 600;
    `}
`;
